import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import RefuelAPI from '../serviceAPI/RefuelAPI';

const initialState = {
  refuelData: [],
  isLoading: false,
  prevThumbnailDetails: null,
  prevThumbnailId: '',
  prevRefuelImageDetails: null,
  prevRefuelIds: null,
  errorCode: null,
  localCurrency: '',
};

export const getAllRefuelData = createAsyncThunk(
  'getAllRefuelData',
  async (id, { rejectWithValue }) => {
    try {
      const res = await RefuelAPI.GetAllRefuelData(id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const updateRefuelOrder = createAsyncThunk(
  'refuel/updateRefuelOrder',
  async ({ officeId, orderedArray }, { rejectWithValue }) => {
    try {
      // orderedArray: [{ _id, name, order }, ...]
      const res = await RefuelAPI.UpdateRefuelOrder(officeId, orderedArray);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.status || 'Network Error');
    }
  }
);

export const createNewRefuelData = createAsyncThunk(
  'createNewRefuelData',
  async ({ newData, id }, { rejectWithValue }) => {
    try {
      const res = await RefuelAPI.CreateNewRefuelData(newData, id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const updateRefuel = createAsyncThunk(
  'updateRefuel',
  async ({ newData, id }, { rejectWithValue }) => {
    try {
      const res = await RefuelAPI.UpdateRefuel(newData, id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const deleteRefuel = createAsyncThunk(
  'deleteRefuel',
  async (id, { rejectWithValue }) => {
    try {
      const res = await RefuelAPI.DeleteRefuel(id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

const RefuelSlice = createSlice({
  name: 'recreation',
  initialState,
  reducers: {
    setPrevThumbnailDetails: (state, action) => {
      state.prevThumbnailDetails = action.payload;
    },
    setPreThumbnailId: (state, action) => {
      state.prevThumbnailId = action.payload;
    },
    setPrevRefuelImageDetails: (state, action) => {
      state.prevRefuelImageDetails = action.payload;
    },
    setPrevRefuelIds: (state, action) => {
      state.prevRefuelIds = action.payload;
    },
    resetErrorAlert: (state, action) => {
      state.errorCode = null;
    },
  },
extraReducers: (builder) => {
  builder
    // getAllRefuelData
    .addCase(getAllRefuelData.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(getAllRefuelData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.refuelData = action.payload.refuelData;
      state.localCurrency = action.payload.localCurrency;
    })
    .addCase(getAllRefuelData.rejected, (state, action) => {
      state.isLoading = false;
      state.errorCode = action.payload;
    })

    // createNewRefuelData
    .addCase(createNewRefuelData.fulfilled, (state, action) => {
      state.refuelData.push(action.payload);
    })
    .addCase(createNewRefuelData.rejected, (state, action) => {
      state.errorCode = action.payload;
    })

    // updateRefuel
    .addCase(updateRefuel.fulfilled, (state, action) => {
      state.refuelData = state.refuelData.map((refuel) =>
        refuel._id === action.payload._id ? action.payload : refuel
      );
    })
    .addCase(updateRefuel.rejected, (state, action) => {
      state.errorCode = action.payload;
    })

    // deleteRefuel
    .addCase(deleteRefuel.fulfilled, (state, action) => {
      const id = action.payload._id;
      const index = state.refuelData.map((item) => item._id).indexOf(id);
      state.refuelData.splice(index, 1);
    })
    .addCase(deleteRefuel.rejected, (state, action) => {
      state.errorCode = action.payload;
    })

    // updateRefuelOrder
    .addCase(updateRefuelOrder.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(updateRefuelOrder.fulfilled, (state) => {
      state.isLoading = false;
    })
    .addCase(updateRefuelOrder.rejected, (state, action) => {
      state.isLoading = false;
      state.errorCode = action.payload;
    });
},
});

export const {
  setPrevThumbnailDetails,
  setPreThumbnailId,
  setPrevRefuelImageDetails,
  setPrevRefuelIds,
  resetErrorAlert,
} = RefuelSlice.actions;
export default RefuelSlice.reducer;